import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slideButton", "carousel"];

  connect() {
    this.setupSlideButtons();
  }

  setupSlideButtons() {
    this.carouselElement = this.element.querySelector(
      '[data-controller="carousel"]'
    );
    if (!this.carouselElement) {
      console.warn("Carousel not found in gallery");
      return;
    }

    this.swiper = this.carouselElement.swiper;
    if (!this.swiper) {
      setTimeout(() => {
        this.setupSlideButtons();
      }, 100);
      return;
    }

    this.updateSlideButtonsState();

    this.swiper.on("slideChange", () => {
      this.updateSlideButtonsState();
    });
  }

  goToSlide(event) {
    if (!this.swiper) {
      console.warn("Swiper not available");
      return;
    }

    const slideIndex = parseInt(event.currentTarget.dataset.slideIndex);
    const groupIndex = parseInt(event.currentTarget.dataset.groupIndex);

    if (!isNaN(slideIndex)) {
      this.swiper.slideTo(slideIndex);
    }
  }

  updateSlideButtonsState() {
    if (!this.swiper || !this.hasSlideButtonTarget) return;

    const activeIndex = this.swiper.activeIndex;

    this.slideButtonTargets.forEach((button, index) => {
      const buttonSlideIndex = parseInt(button.dataset.slideIndex);

      if (buttonSlideIndex === activeIndex) {
        button.classList.add("active");
        button.classList.add("bg-red-600");
        button.classList.add("text-white");
      } else {
        button.classList.remove("active");
        button.classList.remove("bg-red-600");
        button.classList.remove("text-white");
      }
    });
  }
}
